import React from 'react';
import Header from 'features/layout/templates/Layout/components/Header';
import Footer from 'features/layout/templates/Layout/components/Footer';

import { Main, Body } from './TextLayout.styled';

type Props = {
  children: React.ReactNode;
};

export const TextLayout = ({ children }: Props) => {
  return (
    <>
      <Header />
      <Main id="main-layout"> <Body>{children}</Body></Main>
      <Footer />
    </>
  );
};
